import { render, staticRenderFns } from "./DarkColor.vue?vue&type=template&id=2ee52e3d&scoped=true&"
import script from "./DarkColor.vue?vue&type=script&lang=js&"
export * from "./DarkColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee52e3d",
  null
  
)

export default component.exports